@if (splitPlan) {
  <div class="planning-draft-job-split-plan">
    <div class="diff-section-title br-caption-2" translate>Split Plan</div>

    @for (pair of splitPlan.pairs; track pair.fulfillmentStepId) {
      <div class="tr diff-row">
        <div class="td"><span class="br-body-1 tr-label" translate>Pair</span></div>
        <div class="td tr-value--wide layout-row layout-align-start-center">
          <span class="text-ellipsis">{{ pair.draftJobId }}</span>
          <bringoz-icon iconName="arrow-right" classSize="sm" class="margin-left-5 margin-right-5"></bringoz-icon>
          <span class="text-ellipsis">{{ pair.fulfillmentStepId }}</span>
          @if (pair.draftJobId === splitPlan.survivorJobId) {
            <span class="br-caption-2 survivor-label margin-left-10" translate>Survivor</span>
          }
        </div>
      </div>
    }

    @if (splitPlan.leavesNoJob?.length) {
      <div class="tr diff-row">
        <div class="td"><span class="br-body-1 tr-label" translate>New Legs</span></div>
        <div class="td tr-value--wide">
          @for (leafId of splitPlan.leavesNoJob; track leafId) {
            <div class="text-ellipsis">{{ leafId }}</div>
          }
        </div>
      </div>
    }

    @if (splitPlan.jobsNoLeaf?.length) {
      <div class="tr diff-row">
        <div class="td"><span class="br-body-1 tr-label" translate>Jobs With No Leg</span></div>
        <div class="td tr-value--wide">
          @for (jobId of splitPlan.jobsNoLeaf; track jobId) {
            <div class="text-ellipsis">{{ jobId }}</div>
          }
        </div>
      </div>
    }
  </div>
}
